import React from 'react'
import {Paper,TextField} from '@material-ui/core'

class Searchbar extends React.Component{

    state={
        searchTerm:""
    }
    handleChange=(event)=>{
        this.setState({searchTerm:event.target.value})
    }
    handleSubmit = (event)=>{
        event.preventDefault()
        const {searchTerm} = this.state
        const {onFormSubmit} = this.props
        // console.log(searchTerm,onFormSubmit)
        onFormSubmit(searchTerm)
    }
    render(){
        // console.log(this.state.searchTerm)
        return(
            <Paper elevation={6} style ={{padding:'25px'}}>
                <form onSubmit={this.handleSubmit}>
                    <TextField fullWidth label='Search..' onChange={this.handleChange}/>
                </form>
            </Paper>
        )
    }
}

export default Searchbar